import React, { useState } from "react";
import InformationIcon from "icons/InformationIcon";
import Portal from "components/Portal";
import TooltipPopover from "components/TooltipPopover";
import useOutsideClose from "hooks/useOutsideClose";

/**
 * Icono de ayuda que abre un globo (`TooltipPopover`) al hacer click y lo
 * cierra al clickear afuera. `helpText` puede ser texto o un nodo; `width` es
 * el ancho del globo en px (200 por defecto, para las ayudas cortas de los
 * cuestionarios). `label` es el nombre accesible del botón.
 */
export default function Help({ helpText, width, label = "Ayuda" }) {
  const [isOn, setOn] = useState(false); // toggles dropdown visibility
  const [coords, setCoords] = useState({}); // takes current button coordinates

  const { node } = useOutsideClose(() => setOn(false));

  const updateTooltipCoords = (button) => {
    const rect = button.getBoundingClientRect();

    setCoords({
      left: rect.x + rect.width / 2, // add half the width of the button for centering
      top: rect.y + window.scrollY, // add scrollY offset, as soon as getBountingClientRect takes on screen coords
    });
  };

  return (
    <>
      <button
        type="button"
        className="no-print"
        style={{ border: "none", backgroundColor: "transparent" }}
        ref={node}
        aria-label={label}
        title={label}
        aria-expanded={isOn}
        onClick={(e) => {
          e.preventDefault();
          // `currentTarget` es el botón aunque el click haya caído sobre el
          // SVG: con `target` el globo se centraba en el trazo clickeado.
          updateTooltipCoords(e.currentTarget);
          setOn(!isOn);
        }}
      >
        <InformationIcon width="25px" height="25px" color="#006EDF" />
      </button>

      {isOn && (
        <Portal>
          <TooltipPopover
            coords={coords}
            width={width}
            updateTooltipCoords={() => {
              updateTooltipCoords(node.current);
            }}
          >
            <div>{helpText}</div>
          </TooltipPopover>
        </Portal>
      )}
    </>
  );
}
